export default {
	"receiptcreate": {
		"btnReceipt": "回单",
		"electronicReceipt": "电子回单",
		"electronicReceiptStatus": "电子回单状态",
		"electronicReceiptPersonName": "电子回单人",
		"electronicReceiptDt": "电子回单时间",
		"electronicReceiptCheckedDt": "电子回单确认时间",
		"checkedPersonName": "审单人",
		"paperyReceipt": "纸质回单",
		"backCheckedStatus": "纸质回单状态",
		"backPersonName": "回单人",
		"backCheckedPersonName": "回单确认人",
		"backCheckedPersonDt": "回单确认时间",
		"backConfirmDt": "收到回单时间",
		"mailBackDt": "寄出回单时间",
		"expressNo": "快递单号",
		"signPersonDt": "签收时间",
		"backTabInfo": "回单信息",
		"receiptStatusChecked": "已确认",
		"checkedReceipt": "确认回单",
		"receiptStatusBacked": "已回单",
		"emailLog": "回单邮件内容",
		"paperyReceiptForShipperConfirm": "货主回单确认"
	},
	"receiptemail": {
		"sendEmailTips": "是否确认发送邮件？",
		"receiptWait": "待回单"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/receipt/receipt.js